/* global window, document, rp$, Event */

const getFlyouts = () => import(/* webpackChunkName: "get-flyouts" */ 'public/js/elements/flyouts');
let attached = false;
document.querySelectorAll('.flyout-select').forEach((elem) => {
	elem.addEventListener('click', (e) => {
		getFlyouts().then((module) => {
			if (!attached) {
				module.attachEvents();
				module.handleLinkClick(rp$(e.target));
				attached = true;
			}
		});
	});
});
